import { ConfigEHSS as ConfigEHSSinterface, FrequencyType } from '@interfaces/global/config-ehss';
import ConfigService from '@services/global/Config';
import NotificationComponent from '@src/helpers/_showNotifications';
import I18n from '@src/i18n';
import { Button, Checkbox, Input, Radio, Row } from 'antd';
import React from 'react';

import Page from '../components/Page';
import styled from '../styled-components';


const _service: ConfigService = new ConfigService();

interface IProp {
    configToOpen?: ConfigEHSSinterface
}

type StateType = {
    auditedsByAuditor?: any;
    auditedGoalTimes?: any;
    auditedGoalType?: any;
    auditorGoalTimes?: any;
    auditorGoalType?: any;
    remainderDays?: any;
    checked?: boolean;
    somethingHasChanged: boolean;
    Fields?: ConfigEHSSinterface | undefined;
    auditedsByAuditorValidated: boolean;
    auditedGoalTimesValidated: boolean;
    auditedGoalTypeValidated: boolean;
    auditorGoalTimesValidated: boolean;
    auditorGoalTypeValidated: boolean;
    canSave: boolean;
    editItem: any;
};

class AuditSettings extends React.Component<IProp, StateType>{

    constructor(props: IProp) {
        super(props);

        this.state = {
            editItem: this.props.configToOpen,
            auditedsByAuditor: '',
            auditedGoalTimes: '',
            auditedGoalType: '',
            auditorGoalTimes: '',
            auditorGoalType: '',
            remainderDays: '',
            checked: false,
            somethingHasChanged: false,
            auditedsByAuditorValidated: true,
            auditedGoalTimesValidated: true,
            auditedGoalTypeValidated: true,
            auditorGoalTimesValidated: true,
            auditorGoalTypeValidated: true,
            canSave: false
        }
    }

    componentDidMount() {
        this.getConfig();
    }

    getConfig = async () => {
        try {
            const data: any = await _service.getEHSS();
            this.setState({
                auditedsByAuditor: data.auditedsByAuditor,
                auditedGoalTimes: data.auditedGoal.times,
                auditedGoalType: data.auditedGoal.type,
                auditorGoalTimes: data.auditorGoal.times,
                auditorGoalType: data.auditorGoal.type,
                remainderDays: data.remainderDays,
            });
        } catch (error) {
            console.warn(error);
        }
    };

    onSubmit = async (locale: any) => {
        try {

            if (this.state.checked) {
                const data: any = {
                    'auditedsByAuditor': this.state.auditedsByAuditor,
                    'auditedGoal': {
                        'times': this.state.auditedGoalTimes,
                        'type': this.state.auditedGoalType
                    },
                    'auditorGoal': {
                        'times': this.state.auditorGoalTimes,
                        'type': this.state.auditorGoalType
                    },
                    'remainderDays': this.state.remainderDays

                }
                const response = await _service.updateEHSS(data);
                this.setState({
                    somethingHasChanged: false,
                })
                NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.userInfoSuccess"));

            }
            else {
                {
                    const data: any = {
                        'auditedsByAuditor': this.state.auditedsByAuditor,
                        'auditedGoal': {
                            'times': this.state.auditedGoalTimes,
                            'type': this.state.auditedGoalType
                        },
                        'auditorGoal': {
                            'times': this.state.auditorGoalTimes,
                            'type': this.state.auditorGoalType
                        },
                        'remainderDays': undefined
                    }
                    const response = await _service.updateEHSS(data);
                    this.setState({ somethingHasChanged: false })
                    NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.userInfoSuccess"));
                }
            }

        } catch (error) {
            NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), error);
            console.error(error);
        }
    }
    handleAuditByAuditorChange = async (evt: any) => {
        this.setState({ auditedsByAuditor: evt.target.value, somethingHasChanged: true });
        if (this.state.auditedsByAuditor.toString().length > 0)
            this.setState({ auditedsByAuditorValidated: true })
        if (this.state.auditedsByAuditor.toString().length == 0)
            this.setState({ auditedsByAuditorValidated: false })
        console.log(this.state.auditedsByAuditorValidated);

    }
    handleAuditorGoalsTimesChange = async (evt: any) => {
        this.setState({ auditorGoalTimes: evt.target.value, somethingHasChanged: true });
        if (this.state.auditorGoalTimes.toString().length > 0)
            this.setState({ auditorGoalTimesValidated: true })
        if (this.state.auditorGoalTimes.toString().length == 0)
            this.setState({ auditorGoalTimesValidated: false })
        console.log(this.state.auditorGoalTimesValidated);

    }
    handleAuditorGoalsTypesChange = async (evt: any) => {
        this.setState({ auditorGoalType: evt.target.value, somethingHasChanged: true });
        if (this.state.auditorGoalType.toString().length > 0)
            this.setState({ auditorGoalTypeValidated: true })
        if (this.state.auditorGoalType.toString().length == 0)
            this.setState({ auditorGoalTypeValidated: false })
        console.log(this.state.auditorGoalTypeValidated);

    }
    handleAuditedGoalsTimesChange = async (evt: any) => {
        this.setState({ auditedGoalTimes: evt.target.value, somethingHasChanged: true });
        if (this.state.auditedGoalTimes.toString().length > 0)
            this.setState({ auditedGoalTimesValidated: true })
        if (this.state.auditedGoalTimes.toString().length == 0)
            this.setState({ auditedGoalTimesValidated: false })
        console.log(this.state.auditedGoalTimesValidated);

    }
    handleAuditedGoalsTypesChange = async (evt: any) => {
        this.setState({ auditedGoalType: evt.target.value, somethingHasChanged: true });
        if (this.state.auditedGoalType.toString().length > 0)
            this.setState({ auditedGoalTypeValidated: true })
        if (this.state.auditedGoalType.toString().length == 0)
            this.setState({ auditedGoalTypeValidated: false })
        console.log(this.state.auditedGoalTypeValidated);

    }
    handleRemainderdaysTypesChange = (evt: any) => {
        this.setState({ remainderDays: evt.target.value, somethingHasChanged: true });
    }

    onChangeChecked = (evt: any) => {
        this.setState({ checked: evt.target.checked, somethingHasChanged: true });
    }

    render() {
        const {
            somethingHasChanged,
            auditedsByAuditorValidated,
            auditedGoalTimesValidated,
            auditedGoalTypeValidated,
            auditorGoalTimesValidated,
            auditorGoalTypeValidated,
        } = this.state;
        return (
            <Page>
                <Wrapper>
                    <h3 style={{ fontWeight: 'bold' }}>{I18n.l('auditconf.infoauditconf')}</h3>
                    <p>{I18n.l('auditconf.auditbyauditor')}</p>
                    <Input
                        defaultValue={this.state.auditedsByAuditor}
                        onChange={this.handleAuditByAuditorChange}
                        style={{ width: '25%' }}
                        placeholder={I18n.l('auditconf.auditbyauditorPlaceholder')} /><br />
                    <div>
                        <Row>
                            <p>{I18n.l('auditconf.auditorgoalstimes')}</p><Input
                                defaultValue={this.state.auditorGoalTimes}
                                onChange={this.handleAuditorGoalsTimesChange}
                                style={{ width: '40%', marginRight: '10px' }}
                                placeholder={I18n.l('auditconf.goalstimesPlaceholder')}
                            />
                            {I18n.l('auditconf.per')}
                            <Radio.Group defaultValue={this.state.auditorGoalType} onChange={this.handleAuditorGoalsTypesChange} style={{ marginLeft: '10px' }} value={this.state.auditorGoalType} >
                                <Radio.Button value={FrequencyType.MONTHS | 2}>{I18n.l('auditconf.goalsmonth')}</Radio.Button>
                                <Radio.Button value={FrequencyType.YEARS | 3}>{I18n.l('auditconf.goalsyears')}</Radio.Button>
                            </Radio.Group>
                        </Row>
                    </div>
                    <div><br />
                        <Row>
                            <p>{I18n.l('auditconf.auditedgoalstimes')}</p><Input
                                defaultValue={this.state.auditedGoalTimes}
                                onChange={this.handleAuditedGoalsTimesChange}
                                style={{ width: '40%', marginRight: '10px' }}
                                placeholder={I18n.l('auditconf.goalstimesPlaceholder')} />
                            {I18n.l('auditconf.per')}
                            <Radio.Group defaultValue={this.state.auditedGoalType} onChange={this.handleAuditedGoalsTypesChange} style={{ marginLeft: '10px' }} value={this.state.auditedGoalType} >
                                <Radio.Button value={FrequencyType.MONTHS | 2}>{I18n.l('auditconf.goalsmonth')}</Radio.Button>
                                <Radio.Button value={FrequencyType.YEARS | 3}>{I18n.l('auditconf.goalsyears')}</Radio.Button>
                            </Radio.Group>
                        </Row>

                    </div><br />
                    <Checkbox onChange={this.onChangeChecked} >{I18n.l('auditconf.sendnotes')}
                        <Input
                            onChange={this.handleRemainderdaysTypesChange}
                            style={{ width: '10%', textAlign: 'center', marginRight: '5px', marginLeft: '5px' }}
                            placeholder="03" />{I18n.l('auditconf.days')}
                    </Checkbox><br />
                    <Button type="primary" disabled={!(somethingHasChanged &&
                        auditedsByAuditorValidated &&
                        auditedGoalTimesValidated &&
                        auditedGoalTypeValidated &&
                        auditorGoalTimesValidated &&
                        auditorGoalTypeValidated
                    )}
                        onClick={this.onSubmit}>{I18n.l('auditconf.save')}</Button>

                </Wrapper>
            </Page>
        );
    }
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
`;

export default AuditSettings;
